import PropTypes from 'prop-types';
import React from 'react';

import Link from 'components/shared/link';

const CompanyLogo = ({ author, logo, logoUrl }) => (
  <div className="mt-5 flex items-center md:block">
    <div dangerouslySetInnerHTML={{ __html: author }} />
    <Link
      className="ml-5 border-l border-l-gray-5 pl-5 md:mt-5 md:ml-0 md:inline-block md:border-l-0 md:pl-0 md:align-top"
      to={logoUrl}
    >
      <img className="h-7" src={logo.url} alt={logo.alt} loading="lazy" />
    </Link>
  </div>
);

CompanyLogo.propTypes = {
  author: PropTypes.string.isRequired,
  logo: PropTypes.shape({
    alt: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
  logoUrl: PropTypes.string.isRequired,
};

export default CompanyLogo;
